angular.module('scroller')
    .directive('scrollerToTop', scrollToTopDirective);

scrollToTopDirective.$inject = ['$window'];
function scrollToTopDirective($window){

    function linkFunc(scope, element, attrs){
        angular.element($window).bind("scroll", function(event){
            if((typeof (document.getElementById(scope.watchElementId)) !== 'undefined') && (document.getElementById(scope.watchElementId))) {
                var filtersHeight = document.getElementById(scope.watchElementId).scrollHeight;
                if ($window.scrollY > filtersHeight) {
                    element.removeClass('hidden');
                } else {
                    element.addClass('hidden');
                }
            }
        });
        element.bind('click', function(){
            $window.scrollTo(0, 0);
        });
    }

    var directive = {
        restrict: 'EA',
        scope: {
            watchElementId: '@'
        },
        link: linkFunc
    };

    return directive;
}